export default class PatrolBigbutton {
  constructor(view, i18n) {
    this.view = view
    this.i18n = i18n
  }

  showLoading() {
    this.view.innerHTML = `
      <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    `
    this.view.disabled = true
  }

  showStartButton() {
    this.view.innerHTML = `
      <div class="text-center">
        <span class="fs-1 fw-bold">${this.i18n.t("patrols.bigbutton_title")}</span>
        <div class="fs-6">${this.i18n.t("patrols.bigbutton_text")}</div>
      </div>
    `
    this.view.disabled = false
  }

  updateCheckpoint(checkpoint) {
    this.view.innerHTML = `
      <div>
        <strong>${checkpoint.name}</strong>
        <p>${checkpoint.location}</p>
        <small>${checkpoint.instructions}</small>
      </div>
    `
    this.view.disabled = true
  }

  showSubmitting() {
    this.view.classList.remove("btn-danger")
    this.view.innerHTML = `
      <div class="text-center">
        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
        <div>${this.i18n.t("patrols.finish")}</div>
      </div>
    `
    this.view.disabled = true
  }

  showRetryButton() {
    this.view.classList.add("btn-danger")
    this.view.innerHTML = `
      <div class="text-center">
        <div>${this.i18n.t("patrols.retry")}</div>
      </div>
    `
    this.view.disabled = false
  }

}
